export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "Avevo le uscite in bici su un'app, le ripetute di corsa negli appunti e il nuoto… quando capitava. Le sei fasi mi hanno dato finalmente un ordine: adesso so a cosa serve ogni settimana.",
    name: 'Marco B.',
    location: 'Firenze',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/2ba098c5-adeb-4013-b997-edca6829b6f2.jpg',
  },
  {
    quote:
      'Il nuoto era sempre l’allenamento che saltavo. Con il calendario vedo nuoto, bici e corsa tutti insieme e ho smesso di trattarli come tre sport separati. Le mie settimane sono molto più equilibrate.',
    name: 'Giulia R.',
    location: 'Bologna',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/982ffd6d-8cfe-4be4-a20a-c831202bc86e.jpg',
  },
  {
    quote:
      'A 46 anni, con un lavoro a tempo pieno, non posso sprecare allenamenti. Il diario mi fa vedere dove sono e cosa viene dopo. Basta chiedermi se sto facendo troppo o troppo poco.',
    name: 'Andrea C.',
    location: 'Milano',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e5298cf1-521f-4b60-89dd-74893aed3471.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'La guida all’alimentazione era il pezzo che mi mancava. Nelle uscite lunghe finivo sempre senza energie. Ora organizzo cosa mangiare e bere prima di partire, non a metà allenamento.',
    name: 'Francesca M.',
    location: 'Torino',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/bf96fb81-e453-4059-947f-1e541e086737.jpg',
  },
  {
    quote:
      'Il diario di progressione mi tiene onesto. Vedere la mia costanza settimanale nelle tre discipline mi dice molto più di un singolo allenamento duro.',
    name: 'Luca P.',
    location: 'Desenzano del Garda',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/35557477-3841-4ac2-8807-15bed41b9ba4.jpg',
  },
  {
    quote:
      'La settimana di gara per me era sempre un caos. Con la checklist avevo borse pronte, transizioni organizzate e la mattina della gara pianificata. Sono partita tranquilla per la prima volta.',
    name: 'Elena S.',
    location: 'Cagliari',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/515e4dab-45d6-4a7e-b1f3-6d20ad05b3e3.jpg',
  },
];
